<script>
   /****************************************************************
   * SpecificityPlot                                               *
   * --------------------                                          *
   * shows plot with specificity values vs. number of PCs          *
   *****************************************************************/

   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES } from './Defaults.js';
   import StatCompPlot from './StatCompPlot.svelte';

   export let params;                     // JSON with main plot parameters
   export let res;                        // JSON with SIMCA results
   export let ncomp = 1;                  // number of components selected by user

   export let fileName = 'plot-specificity';
   export let pngWidth = PNG_WIDTH;
   export let pngHeight = PNG_HEIGHT;
   export let pngRes = PNG_RES;


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const xLabel = 'Number of PCs';
   const yLabel = 'Specificity';
   const title = 'Specificity plot';

   // reactive computation of y limits
   $: limYMin = params && params.zoom === 'on' ? null : -0.1;
   $: limYMax = params && params.zoom === 'on' ? null : 1.1;
</script>

{#if res }
<StatCompPlot
   {res} {ncomp} {params} {limYMax} {limYMin}
   {title} {xLabel} {yLabel} {fileName}
   {pngWidth} {pngHeight} {pngRes}
   statName='specificity'
>

</StatCompPlot>
{/if}